import React, { useState, useEffect, useContext } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { DataContext } from "../../../context/DataContext";
import { getToken } from "../../../api/Account";
import { getFlujoCajaSemanalAsync } from "../../../api/Dashboard";
import { simpleMessage } from "../../../helpers/Helpers";
import { chartPalette, chartTextColor, chartGridColor } from "../../../theme";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const dayName = (fecha) =>
  ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"][new Date(fecha).getDay()];

const FlujoCaja = ({ selectedSucursal }) => {
  const [labels, setLabels] = useState([]);
  const [colocacion, setColocacion] = useState([]);
  const [recuperacion, setRecuperacion] = useState([]);

  const { setIsLoading, setIsUnautorized, isDarkMode } = useContext(DataContext);

  const token = getToken();

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const result = await getFlujoCajaSemanalAsync(token, selectedSucursal);
      if (!result.statusResponse) {
        setIsLoading(false);
        if (result.error === "Unauthorized") {
          setIsUnautorized(true);
          return;
        }
        simpleMessage(result.error, "error");
        return;
      }

      setIsLoading(false);

      let dias = [];
      let coloc = [];
      let recup = [];
      result.data.result.forEach((item) => {
        dias.push(dayName(item.fecha));
        coloc.push(item.colocacion);
        recup.push(item.recuperacion);
      });
      setLabels(dias);
      setColocacion(coloc);
      setRecuperacion(recup);
    })();
  }, [selectedSucursal]);

  const textColor = chartTextColor(isDarkMode);
  const gridColor = chartGridColor(isDarkMode);
  const palette = chartPalette(isDarkMode, 2);

  const options = {
    responsive: true,
    aspectRatio: 5,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
        align: "center",
        labels: { color: textColor },
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            let label = context.dataset.label || "";

            if (label) {
              label += ": ";
            }
            if (context.parsed.y !== null) {
              label += new Intl.NumberFormat("es-NI", {
                style: "currency",
                currency: "NIO",
              }).format(context.parsed.y);
            }
            return label;
          },
        },
      },
    },

    scales: {
      x: {
        ticks: { color: textColor },
        grid: { color: gridColor },
      },
      y: {
        ticks: {
          color: textColor,
          callback: (value) => {
            return new Intl.NumberFormat("es-NI", {
              style: "currency",
              currency: "NIO",
            }).format(value);
          },
        },
        grid: { color: gridColor },
        beginAtZero: true,
      },
    },
  };

  const dataSet = {
    labels,
    datasets: [
      {
        label: "Colocación",
        data: colocacion,
        backgroundColor: palette.bg[0],
        borderColor: palette.border[0],
        borderWidth: 1,
        maxBarThickness: 40,
        borderRadius: 6,
      },
      {
        label: "Recuperación",
        data: recuperacion,
        backgroundColor: palette.bg[1],
        borderColor: palette.border[1],
        borderWidth: 1,
        maxBarThickness: 40,
        borderRadius: 6,
      },
    ],
  };

  return (
    <div>
      <Bar data={dataSet} options={options} />
    </div>
  );
};

export default FlujoCaja;
